module.exports = __webpack_public_path__ + "static/media/onboardingExisting.c7343103.png";